/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthScoreModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import { OperationalState } from 'generated-types';

/**
 * @description Component to render a status circle icon based on the OperationalState enum value.
 * @author alextsg
 */
@Component({
    selector: 'operational-state-icon',
    templateUrl: './operational-state-icon.component.html',
})
export class OperationalStateIconComponent {
    @Input()
    public value: OperationalState;

    @Input()
    public size ? = '14';
}
